<template>
    <div id="app" style="margin-top: 0">
        <!--link to使用如下字符串形式时,映射对应path-->
        <!-- <router-link to="/jxwx/dean?today=2020-07-21#/">1</router-link>  -->
        <router-view></router-view>
    </div>
</template>

<script>
import api from "@/axios/api";
import request from "@/axios/token";
import { mapGetters, mapActions } from "vuex";
export default {
    name: "App",
    computed: {
        ...mapGetters(["token"])
    },
    created() {
        if(this.token == undefined || this.token == ""){
            let code = window.location.href.split("?code=")[1];
            if (code != undefined) {
                request.getToken();
            } else {
                request.getCode();
            }
        }
    },
    mounted(){
        // window.addEventListener(
        //     "hashchange",
        //     () => {
        //         var currentPath = window.location.hash.slice(1); // 获取输入的路由
        //         if (this.$router.path !== currentPath) {
        //             this.$router.push(currentPath); // 动态跳转
        //         }
        //     },
        //     false
        // );
    },
    methods: {
        // ...mapActions({
        //     saveToken: "saveToken",
        // }),
        // getCode() {
        //     let url = escape(window.location);
        //     window.location.href =
        //         "https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww22141d223bc1a1ad&redirect_uri=" +
        //         url +
        //         "?agentId=1000035&response_type=code&scope=snsapi_base&state=&connect_redirect=1#wechat_redirect";
        // },
        // getToken() {
        //     let code = window.location.href.split("&code=")[1].split("#/")[0];
        //     console.log(code);
        //     let par = {
        //         code: code,
        //         agentId: "1000035"
        //     };
        //     api.getToken(par).then(res => {
        //         let token = res.token;
        //         this.saveToken(token);
        //     });
        // }
    }
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue